import { Controller } from "@hotwired/stimulus"

// UniversalChatbot's own assistant: the floating chat on our sites and portals.
//
// chatbot.js hangs the launcher off the body, outside anything this page
// renders, so the widget would not survive navigation on its own. A morph
// refresh is told to leave it alone. A full visit replaces the body, which
// reconnects this controller, and it mounts the widget again: chatbot.js mounts
// idempotently and the conversation resumes from the visitor's stored identity.
//
// The portals turn the greeting bubble off; the launcher stays.
//
// "Sign out" links carry data-assistant-chat-logout, so the chat forgets the
// signed-in person before the next one uses this browser.
const WIDGET = ".ucb-chatbot-widget"

export default class extends Controller {
  static values = { scriptSrc: String, botUrl: String, userToken: String, greeting: { type: Boolean, default: true } }

  connect() {
    this.keepWidget = (event) => {
      if (this.isWidget(event.target)) event.preventDefault()
    }
    this.signOut = (event) => {
      if (event.target.closest("[data-assistant-chat-logout]")) window.UCBChatbotWidgets?.[this.botUrlValue]?.logout()
    }
    document.addEventListener("turbo:before-morph-element", this.keepWidget)
    document.addEventListener("click", this.signOut)

    this.mount()
  }

  disconnect() {
    document.removeEventListener("turbo:before-morph-element", this.keepWidget)
    document.removeEventListener("click", this.signOut)
  }

  isWidget(node) {
    return node instanceof Element && node.matches(WIDGET) && node.dataset.ucbBotUrl === this.botUrlValue
  }

  mount() {
    if ([...document.body.children].some((node) => this.isWidget(node))) return

    document.querySelector("script[data-assistant-chat]")?.remove()

    const script = document.createElement("script")
    script.async = true
    script.src = this.scriptSrcValue
    script.dataset.botUrl = this.botUrlValue
    // Our pages switch theme with a class rather than following the OS.
    script.dataset.theme = "tailwind_class"
    if (this.userTokenValue) script.dataset.userToken = this.userTokenValue
    if (!this.greetingValue) script.dataset.showGreeting = "false"
    script.dataset.assistantChat = "true"
    document.body.appendChild(script)
  }
}
